module.exports = "/lucky-balls/img/regular_game/check_infoBar/check_001.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/regular_game/check_infoBar/check_001.png
// module id = 1125
// module chunks = 0